import PlansInterceptor from '../PlansInterceptor'

const api = new PlansInterceptor()

export default {
}
